import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Service from './service';
import { getServicesUrl, V11, V20 } from '../../setup';

var Messages =
/*#__PURE__*/
function (_Service) {
  _inherits(Messages, _Service);

  function Messages() {
    _classCallCheck(this, Messages);

    return _possibleConstructorReturn(this, _getPrototypeOf(Messages).apply(this, arguments));
  }

  _createClass(Messages, null, [{
    key: "getMemberInboxMessages",
    value: function getMemberInboxMessages(_ref) {
      var _ref$pageNumber = _ref.pageNumber,
          pageNumber = _ref$pageNumber === void 0 ? 1 : _ref$pageNumber,
          _ref$pageSize = _ref.pageSize,
          pageSize = _ref$pageSize === void 0 ? 50 : _ref$pageSize,
          memberId = _ref.memberId,
          isRead = _ref.isRead,
          rest = _objectWithoutProperties(_ref, ["pageNumber", "pageSize", "memberId", "isRead"]);

      return Service.postRequest("".concat(getServicesUrl(V20), "/members/").concat(memberId, "/messages/inbox"), _objectSpread({
        PageNumber: pageNumber,
        PageSize: pageSize,
        IsRead: isRead
      }, rest), {
        isSecure: true
      });
    }
  }, {
    key: "getClientInboxMessages",
    value: function getClientInboxMessages(_ref2) {
      var _ref2$pageNumber = _ref2.pageNumber,
          pageNumber = _ref2$pageNumber === void 0 ? 1 : _ref2$pageNumber,
          _ref2$pageSize = _ref2.pageSize,
          pageSize = _ref2$pageSize === void 0 ? 50 : _ref2$pageSize,
          contactId = _ref2.contactId,
          memberId = _ref2.memberId,
          isRead = _ref2.isRead,
          rest = _objectWithoutProperties(_ref2, ["pageNumber", "pageSize", "contactId", "memberId", "isRead"]);

      var senderIds = memberId !== undefined ? {
        SenderIds: [memberId]
      } : {};
      return Service.postRequest("".concat(getServicesUrl(V20), "/contacts/").concat(contactId, "/messages/inbox"), _objectSpread({
        PageNumber: pageNumber,
        PageSize: pageSize,
        IsRead: isRead
      }, senderIds, {}, rest), {
        isSecure: true
      });
    }
  }, {
    key: "getClientSentMessages",
    value: function getClientSentMessages(_ref3, contactId, memberId) {
      var _ref3$pageNumber = _ref3.pageNumber,
          pageNumber = _ref3$pageNumber === void 0 ? 1 : _ref3$pageNumber,
          _ref3$pageSize = _ref3.pageSize,
          pageSize = _ref3$pageSize === void 0 ? 50 : _ref3$pageSize,
          rest = _objectWithoutProperties(_ref3, ["pageNumber", "pageSize"]);

      var recipientIds = memberId !== undefined ? {
        RecipientIds: [memberId]
      } : {};
      return Service.postRequest("".concat(getServicesUrl(V20), "/contacts/").concat(contactId, "/messages/sent"), _objectSpread({
        PageNumber: pageNumber,
        PageSize: pageSize
      }, recipientIds, {}, rest), {
        isSecure: true
      });
    }
  }, {
    key: "getMemberSentMessages",
    value: function getMemberSentMessages(_ref4, memberId) {
      var _ref4$pageNumber = _ref4.pageNumber,
          pageNumber = _ref4$pageNumber === void 0 ? 1 : _ref4$pageNumber,
          _ref4$pageSize = _ref4.pageSize,
          pageSize = _ref4$pageSize === void 0 ? 50 : _ref4$pageSize,
          rest = _objectWithoutProperties(_ref4, ["pageNumber", "pageSize"]);

      return Service.postRequest("".concat(getServicesUrl(V20), "/members/").concat(memberId, "/messages/sent"), _objectSpread({
        PageNumber: pageNumber,
        PageSize: pageSize
      }, rest), {
        isSecure: true
      });
    }
  }, {
    key: "getNumberOfUnreadMessages",
    value: function getNumberOfUnreadMessages(contactId) {
      return Service.getRequest("".concat(getServicesUrl(), "/persons/").concat(contactId, "/messages/unread/count"), {
        isSecure: true
      });
    }
  }, {
    key: "readMessage",
    value: function readMessage(id, contactId) {
      return Service.patchRequest("".concat(getServicesUrl(V11), "/persons/").concat(contactId, "/messages/").concat(id), {
        IsRead: true
      }, {
        isSecure: true
      });
    }
  }, {
    key: "deleteMessage",
    value: function deleteMessage(id, contactId) {
      return Service.deleteRequest("".concat(getServicesUrl(), "/persons/").concat(contactId, "/messages/").concat(id), {
        isSecure: true
      });
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(_ref5) {
      var contactId = _ref5.contactId,
          contactReason = _ref5.contactReason,
          subject = _ref5.subject,
          message = _ref5.message,
          memberId = _ref5.memberId,
          dtoAttachments = _ref5.dtoAttachments;
      return Service.postRequest("".concat(getServicesUrl(V11), "/persons/").concat(contactId, "/messages"), {
        ContactMessageSourceId: 1,
        ContactMessageSubtypeId: contactReason,
        Subject: subject,
        Text: message,
        RecipientId: memberId,
        Attachments: dtoAttachments.map(function (item) {
          return {
            FileName: item.OriginalFilename,
            Content: item.File
          };
        })
      }, {
        isSecure: true
      });
    }
  }, {
    key: "sendMessageFromContact",
    value: function sendMessageFromContact(_ref6) {
      var contactId = _ref6.contactId,
          contactReason = _ref6.contactReason,
          subject = _ref6.subject,
          message = _ref6.message,
          dtoAttachments = _ref6.dtoAttachments;
      return Service.postRequest("".concat(getServicesUrl(V20), "/contacts/").concat(contactId, "/messages/send"), {
        SubtypeId: contactReason,
        Subject: subject,
        Text: message,
        Attachments: dtoAttachments.map(function (item) {
          return {
            FileName: item.OriginalFilename,
            Content: item.File
          };
        })
      }, {
        isSecure: true
      });
    }
  }, {
    key: "sendMessageFromContactToMember",
    value: function sendMessageFromContactToMember(_ref7) {
      var contactId = _ref7.contactId,
          contactReason = _ref7.contactReason,
          subject = _ref7.subject,
          message = _ref7.message,
          memberId = _ref7.memberId,
          dtoAttachments = _ref7.dtoAttachments;
      return Service.postRequest("".concat(getServicesUrl(V20), "/contacts/").concat(contactId, "/members/").concat(memberId, "/messages/send"), {
        SubtypeId: contactReason,
        Subject: subject,
        Text: message,
        Attachments: dtoAttachments.map(function (item) {
          return {
            FileName: item.OriginalFilename,
            Content: item.File
          };
        })
      }, {
        isSecure: true
      });
    }
  }, {
    key: "sendMessageFromMember",
    value: function sendMessageFromMember(_ref8) {
      var contactReason = _ref8.contactReason,
          subject = _ref8.subject,
          message = _ref8.message,
          memberId = _ref8.memberId,
          dtoAttachments = _ref8.dtoAttachments,
          recipientIds = _ref8.recipientIds;
      return Service.postRequest("".concat(getServicesUrl(V20), "/members/").concat(memberId, "/messages/send"), {
        RecipientIds: recipientIds,
        SubtypeId: contactReason,
        Subject: subject,
        Text: message,
        Attachments: dtoAttachments.map(function (item) {
          return {
            FileName: item.OriginalFilename,
            Content: item.File
          };
        })
      }, {
        isSecure: true
      });
    }
  }, {
    key: "replyMessage",
    value: function replyMessage(_ref9) {
      var personId = _ref9.personId,
          Subject = _ref9.subject,
          message = _ref9.message,
          messageId = _ref9.messageId,
          dtoAttachments = _ref9.dtoAttachments;
      return Service.postRequest("".concat(getServicesUrl(V20), "/persons/").concat(personId, "/messages/").concat(messageId, "/reply"), {
        Subject: Subject,
        Text: message,
        Attachments: dtoAttachments.map(function (item) {
          return {
            FileName: item.OriginalFilename,
            Content: item.File
          };
        })
      }, {
        isSecure: true
      });
    }
  }, {
    key: "getContactThreads",
    value: function getContactThreads(contactId, _ref10) {
      var ThreadId = _ref10.ThreadId,
          rest = _objectWithoutProperties(_ref10, ["ThreadId"]);

      return Service.postRequest("".concat(getServicesUrl(V20), "/contacts/").concat(contactId, "/message/threads"), _objectSpread({
        ThreadId: ThreadId
      }, rest), {
        isSecure: true
      });
    }
  }, {
    key: "getMemberThreads",
    value: function getMemberThreads(memberId, _ref11) {
      var ThreadId = _ref11.ThreadId,
          rest = _objectWithoutProperties(_ref11, ["ThreadId"]);

      return Service.postRequest("".concat(getServicesUrl(V20), "/members/").concat(memberId, "/hierarchy/message/threads"), _objectSpread({
        ThreadId: ThreadId
      }, rest), {
        isSecure: true
      });
    }
  }, {
    key: "getMessageTypes",
    value: function getMessageTypes() {
      return Service.getRequest("".concat(getServicesUrl(V20), "/message-types"), {
        isSecure: true
      });
    }
  }, {
    key: "getMessageAttachment",
    value: function getMessageAttachment(personId, messageId, attachmentId) {
      return Service.getRequest("".concat(getServicesUrl(V20), "/persons/").concat(personId, "/messages/").concat(messageId, "/attachments/").concat(attachmentId), {
        isSecure: true
      });
    }
  }, {
    key: "getMessageContent",
    value: function getMessageContent(id, contactId) {
      return Service.getRequest("".concat(getServicesUrl(V20), "/persons/").concat(contactId, "/messages/").concat(id), {
        isSecure: true
      });
    }
  }]);

  return Messages;
}(Service);

_defineProperty(Messages, "MESSAGE_NOT_ALLOWED", 'MessageNotAllowed');

_defineProperty(Messages, "SUCCESS", 'Success');

export default Messages;